import { sanitizePartialCurrencyValue } from '../../components/currencyInput/CurrencyInput.helpers';
import { Currency } from '../../components/input/Input';

export const currencyToNumber = (value: string, currency: Currency) => {
  return Number(sanitizePartialCurrencyValue(value, currency));
};
